import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/platform/components/language-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/platform/components/loading.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/platform/lib/datadog/init.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/platform/styles/global.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@4.9.2_next@15.5.28_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@types+node@24_d92272aaf94ddacbfdf93edacbe72cbb/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.28_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@types+node@24.11.0_react-dom@19.2.8_react@19.2.8__react@19.2.8/node_modules/next/font/local/target.css?{\"path\":\"lib/fonts/index.ts\",\"import\":\"\",\"arguments\":[{\"src\":\"./montserrat-latin.woff2\",\"weight\":\"100 900\",\"style\":\"normal\",\"display\":\"swap\",\"fallback\":[\"sans-serif\"]}],\"variableName\":\"montserrat\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/packages/ui/src/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/styles/globals.css");
